// Copyright (c) 2023. Engie-Electrabel. All rights reserved.
//
// Engie-Electrabel n.v./s.a., Simon Bolivarlaan 34 Boulevard Simón Bolivar, BTW BE 0403.107.701 - 1000 Brussel/Bruxelles, Belgium.
//
// Proprietary Notice:
// This software is the confidential and proprietary information of Engie-Electrabel s.a./n.v. and/or its licensors.
// You shall not disclose this Confidential Information to any third parties and any use thereof shall be subject to the terms and conditions of use, as agreed upon with Engie-Electrabel in writing.
//
/// <reference types="vite/client" />
/// <reference types="element-plus/global" />
/// <reference types="@service-portal/commons/types" />
import {RouteNames} from '@/route-names'
import {UserRoles} from '@service-portal/commons'

window.routes ??= []
window.routes.push([
  {
    path: '/service-desk',
    name: RouteNames.ServiceDesk,
    component: () => import('views/GenericRouterView.vue'),
    meta: {
      title: 'Service Desk',
      icon: 'clipboard-list',
      requiresAuth: true,
      showInMenu: true,
      standAlone: true,
      buildInfo: {
        buildId: import.meta.env.buildID,
        buildDate: import.meta.env.buildDate
      }
    },
    redirect: {name: RouteNames.IncidentList},
    children: [
      {
        path: 'incident/create',
        component: () => import('views/TicketCreate.vue'),
        name: RouteNames.IncidentCreate,
        meta: {
          title: 'Create',
          requiresAuth: true,
          showInMenu: false,
          menuItem: RouteNames.IncidentList
        }
      },
      {
        path: 'incident/list',
        component: () => import('views/TicketList.vue'),
        name: RouteNames.IncidentList,
        meta: {
          title: 'Incidents',
          requiresAuth: true,
          showInMenu: true
        }
      },
      {
        path: 'incident/view/:id',
        component: () => import('views/TicketView.vue'),
        name: RouteNames.IncidentView,
        props: true,
        meta: {
          title: '#{id}',
          requiresAuth: true,
          showInMenu: false,
          menuItem: RouteNames.IncidentList
        }
      },
      {
        path: 'incident/edit/:id',
        component: () => import('views/TicketCreate.vue'),
        name: RouteNames.IncidentEdit,
        props: true,
        meta: {
          title: 'Edit #{id}',
          requiresAuth: true,
          showInMenu: false,
          menuItem: RouteNames.IncidentList
        }
      },
      {
        path: 'change-requests/create',
        component: () => import('views/TicketCreate.vue'),
        name: RouteNames.ChangeRequestCreate,
        meta: {
          title: 'Create',
          requiresAuth: true,
          showInMenu: false,
          menuItem: RouteNames.ChangeRequestList
        }
      },
      {
        path: 'change-requests/list',
        component: () => import('views/TicketList.vue'),
        name: RouteNames.ChangeRequestList,
        meta: {
          title: 'Change Requests',
          requiresAuth: true,
          showInMenu: true
        }
      },
      {
        path: 'change-requests/view/:id',
        component: () => import('views/TicketView.vue'),
        name: RouteNames.ChangeRequestView,
        props: true,
        meta: {
          title: '#{id}',
          requiresAuth: true,
          showInMenu: false,
          menuItem: RouteNames.ChangeRequestList
        }
      },
      {
        path: 'change-requests/edit/:id',
        component: () => import('views/TicketCreate.vue'),
        name: RouteNames.ChangeRequestEdit,
        props: true,
        meta: {
          title: 'Edit #{id}',
          requiresAuth: true,
          showInMenu: false,
          menuItem: RouteNames.ChangeRequestList
        }
      },
      {
        path: 'admin',
        component: () => import('views/AdminView.vue'),
        name: RouteNames.ServiceDeskAdmin,
        props: true,
        meta: {
          title: 'Admin',
          requiresAuth: true,
          roles: [UserRoles.ServiceDeskManager],
          showInMenu: true,
          menuItem: RouteNames.ChangeRequestList
        }
      }
    ]
  }
])
